exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1[data-v-1199214c],h2[data-v-1199214c]{font-weight:400}ul[data-v-1199214c]{list-style-type:none;padding:0}li[data-v-1199214c]{display:inline-block;margin:0 10px}a[data-v-1199214c]{color:#42b983}.scrollbar_wrapper[data-v-1199214c]{height:300px;overflow:hidden}.scrollbar_wrapper .list[data-v-1199214c]{max-height:200px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1199214c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/packages/demo/demo.vue
// module id = 21
// module chunks = 0